import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_4: FaireProductEntity = {
  token: "catalog_prod_prod-4",
  type: "product",
  name: "Reversible Lumbar Pillow - Best Day Ever, With Tassels",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1602874801007-bd458bb1b8b6?w=400&h=400&fit=crop",
  priceDollars: 56,
  msrpDollars: 140,
  sku: "CO0004",
  caseSize: 1,
  material: "Cotton",
  collectionToken: "col_confetti-cake",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 314,
  description: "Beautiful Confetti & Cake piece perfect for any home.",
  categoryTokens: ["catalog_cat_stickers-pins"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
